module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid31_980x867.2cff2b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid31_980x867.jpg
// module id = LNft
// module chunks = 0